import { useState, useCallback } from 'react'
import { Component as ComponentIcon, CopyPlus, PencilLine, Trash2 } from 'lucide-react'
import { useHistory } from 'react-router-dom'
import { AdminHeader } from '@components/layout/admin-header'
import { Toolbar } from '@components/layout/toolbar'
import { Button } from '@components/v2/button'
import { useListsQuery } from '@global/hooks/queries/useListsQuery'
import { ExportModal } from './components/export-modal'
import { ListsTable } from './components/lists-table'
import { useShiftSelectable } from '../hooks/useShiftSelectable'
import { t } from '@lingui/core/macro'

export const ListsManager = () => {
  const history = useHistory()
  const { data: lists } = useListsQuery({})
  const [isExportModalOpen, setIsExportModalOpen] = useState(false)

  const {
    selected: selectedRows,
    setSelected: setSelectedRows,
    handleRowClick: handleCheckboxClick,
    numberOfSelected,
  } = useShiftSelectable()

  const handleSelectAllRows = useCallback(
    displayedData => {
      if (numberOfSelected === displayedData.length) {
        setSelectedRows({})
      } else {
        setSelectedRows(
          displayedData.reduce(
            (memo, item) => ({
              ...memo,
              [item.id]: true,
            }),
            {},
          ),
        )
      }
    },
    [numberOfSelected, selectedRows, setSelectedRows],
  )

  const handleDuplicate = id => {
    history.push(`/admin/lists/edit/new?duplicate=${id}`)
  }
  const handleEdit = id => {
    history.push(`/admin/lists-manager/edit/${id}`)
  }
  const handleDelete = () => {
    console.log(selectedRows)
  }

  return (
    <div>
      <AdminHeader>
        <AdminHeader.PageIcon>
          <ComponentIcon color="hsla(194, 47%, 20%, 1)" size={28} />
        </AdminHeader.PageIcon>
        <div className="ml-4">
          <AdminHeader.Title>{t`Lists`}</AdminHeader.Title>
          <AdminHeader.Subtitle>
            {t`Collections of options for users to select from when creating submissions.`}
          </AdminHeader.Subtitle>
        </div>
      </AdminHeader>
      <Toolbar>
        <Toolbar.Search callback={null} onKeyPress={null} onChange={null} />

        <Toolbar.Left>
          <></>
        </Toolbar.Left>

        <Toolbar.Right>
          <Button
            onClick={() => {
              handleDuplicate(Object.keys(selectedRows)[0])
            }}
            disabled={numberOfSelected !== 1}
            variant="secondary"
            className="font-sans font-medium ml-4 text-cv-blue-700 disabled:!bg-[#E3EAEC] disabled:!border-cv-blue-300 !disabled:text-[#8E9EA5]"
          >
            <span className="flex gap-2 items-center">
              <CopyPlus size={21} />
              {t`Duplicate`}
            </span>
          </Button>
          <Button
            onClick={() => {
              handleEdit(Object.keys(selectedRows)[0])
            }}
            disabled={numberOfSelected !== 1}
            variant="secondary"
            className="font-sans font-medium ml-4 text-cv-blue-700 disabled:!bg-[#E3EAEC] disabled:!border-cv-blue-300 !disabled:text-[#8E9EA5]"
          >
            <span className="flex gap-2 items-center">
              <PencilLine size={21} />
              {t`Edit`}
            </span>
          </Button>
          <Button
            disabled={!numberOfSelected}
            onClick={handleDelete}
            variant="primary"
            className="font-sans font-medium ml-4 !text-cv-red-500 !bg-cv-red-200 !border-cv-red-50 disabled:!bg-cv-red-100"
          >
            <span className="flex gap-2 items-center">
              <Trash2 size={21} color="var(--clvn-red-500)" />
              {t`Delete`}
            </span>
          </Button>
        </Toolbar.Right>
      </Toolbar>

      <ExportModal
        isOpen={isExportModalOpen}
        setIsOpen={setIsExportModalOpen}
        selectedLists={lists?.filter(list => selectedRows[list.id]) || []}
      />

      <ListsTable
        lists={lists}
        selectedRows={selectedRows}
        handleEdit={handleEdit}
        handleCheckboxClick={handleCheckboxClick}
        numberOfSelected={numberOfSelected}
        handleSelectAllRows={handleSelectAllRows}
      />
    </div>
  )
}
